import React, { useEffect, useCallback } from 'react';
import { useHeader, useHeaderLinks } from 'providers/AreasProvider';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Grid } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { IconButton, Typography } from '@totalsoft/rocket-ui';
import PropTypes from 'prop-types';

const InsuranceFlowChecksHeader = ({ title }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const [, setHeader] = useHeader();
  const [, setHeaderLinks] = useHeaderLinks();

  useEffect(() => {
    setHeader(
      <Grid container alignItems='center'>
        <Grid item>
          <Typography>{title}</Typography>
        </Grid>
      </Grid>
    );
  }, [setHeader, title]);

  const handleBackToListClick = useCallback(() => {
    history.push('/settings');
  }, [history]);

  useEffect(() => {
    setHeaderLinks(
      <IconButton onClick={handleBackToListClick} color='primary' variant='text' tooltip={t('Tooltips.Back')}>
        <ArrowBack />
      </IconButton>
    );
  }, [handleBackToListClick, setHeaderLinks, t]);

  return <></>;
};

InsuranceFlowChecksHeader.propTypes = {
  title: PropTypes.string
};

export default InsuranceFlowChecksHeader;
